export default "__VITE_ASSET__CM_z0elW__"